module.exports = __webpack_public_path__ + "img/overdue.0cb50a79.png";